import { GridItem, Text } from '@chakra-ui/react';
import * as Case from 'case';

import { gradients } from '../../theme';

export type InsightsItemProps = {
  label: string | JSX.Element;
  value?: string | number | JSX.Element;
  tag?: string;
};

export const InsightsTableItem = ({ label, value, tag }: InsightsItemProps) => (
  <GridItem p="space.16" display="inline-block" position="relative">
    <Text as="span" display="block" fontSize="xs" fontWeight="medium" color="gray.4" mb="space.4">
      {label}
    </Text>
    <Text as="span" fontSize="lg">
      {value}
    </Text>
    {tag && (
      <Text
        bg={gradients.text}
        bgClip="text"
        textAlign="right"
        right="2"
        bottom="2"
        position="absolute"
        fontSize="xs"
        fontWeight="600"
      >
        {Case.capital(tag)}
      </Text>
    )}
  </GridItem>
);
